import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/refunds")({});
